export default __webpack_public_path__ + "static/upkeep-logo-white-1ddea48e407cc1f9c1b15109067e6209.svg";